import React, { createContext, useEffect, useState } from 'react';

import { checkToken, login as loginRequest } from "../../api/apiRequests";
import storage from "../../utils/storage";

export const SessionContext = createContext([]);

const SessionWrapper = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(null)

  useEffect(() => {
    checkToken()
      .then(() => setIsLoggedIn(true))
      .catch(() => setIsLoggedIn(false))
  }, [])


  const login = (email, password) => {
    loginRequest({ email, password })
      .then((res) => {
        storage.userToken.set(res.data)
        setIsLoggedIn(true)
      })
      .catch(() => {
        setIsLoggedIn(false)
        alert("El usuario introducido no es valido")
      });
  };

  const logout = () => {
    setIsLoggedIn(false)
    storage.userToken.remove()
  };

  return (
    <SessionContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </SessionContext.Provider>
  )
}
export default SessionWrapper;
